/**
 * Inline alert notification system
 * Handles dismissal for inline (non-toast) alert notifications
 * Toast notifications are handled by notification-system.js
 */

document.addEventListener('DOMContentLoaded', function() {
    initializeAlerts();
});

function initializeAlerts() {
    // Handle manual dismiss buttons for inline alerts
    document.addEventListener('click', function(e) {
        if (e.target.closest('.alert-dismiss-btn')) {
            const alert = e.target.closest('.alert-notification');
            if (alert && alert.classList.contains('alert-inline')) {
                dismissAlert(alert);
            }
        }
    });
}

function dismissAlert(alertElement) {
    if (!alertElement || !alertElement.parentNode) return;
    alertElement.remove();
}

// Public API for inline alert management
window.InterPals = window.InterPals || {};
window.InterPals.alerts = {
    dismiss: dismissAlert,
    initialize: initializeAlerts,

    // Clear all inline alerts of a specific type
    clearType: function(type) {
        const alerts = document.querySelectorAll(`.alert-inline[data-type="${type}"]`);
        alerts.forEach(alert => dismissAlert(alert));
    },

    // Clear all inline alerts
    clearAll: function() {
        const alerts = document.querySelectorAll('.alert-inline');
        alerts.forEach(alert => dismissAlert(alert));
    }
};